import React, {FC} from "react";
import {Box, Divider, Tooltip} from "@material-ui/core";
import ListOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import ReceiptFilledIcon from "@material-ui/icons/Receipt";
import StoreMallDirectoryRoundedIcon from "@material-ui/icons/StoreMallDirectoryRounded";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import PackageIcon from "view/images/PackageIcon";
import {
  APP_PATH,
  CUSTOM_OPTIONS_PATH,
  OUTSTANDING_PAYMENTS_PATH,
  PRODUCTS_LIST,
  SETTINGS_PATH,
  SHOW_ORDERS_PATH,
  SHOW_ORGANISER_SHOPPING_PATH,
  SHOW_PRODUCTS_LIST_PATH,
  SHOW_SETTINGS_PATH,
  SHOW_USERS_PATH,
} from "view/routes";
import {generatePath, useParams} from "react-router-dom";
import useLocalizedLocalMap from "hooks/useLocalizedLocalMap";
import CustomProductOptionIcon from "view/images/CustomProductOptionIcon";
import {useCurrentShow, useIsSupplierCompanyAdmin} from "hooks";
import DisabledShopIcon from "view/components/DisabledShopIcon";
import NavItem, {NavList} from "./Nav";

type ShowNavigationProps = {
  showId: string;
};

const ShowNavigation: FC<ShowNavigationProps> = ({showId}) => {
  const localMap = useLocalizedLocalMap();
  const [show, isLoading] = useCurrentShow();

  const isShopDisabled = !isLoading && !!show && !show.isShopEnabled;

  return (
    <Box>
      <NavList>
        <NavItem
          to={generatePath(SHOW_PRODUCTS_LIST_PATH, {showId})}
          icon={PackageIcon}
          name="Products"
        />
        <NavItem
          to={generatePath(SHOW_ORDERS_PATH, {showId})}
          icon={ReceiptFilledIcon}
          name="Orders"
        />
        <NavItem
          to={generatePath(SHOW_USERS_PATH, {showId})}
          icon={ListOutlinedIcon}
          name="Users"
        />
        <NavItem
          to={generatePath(SHOW_ORGANISER_SHOPPING_PATH, {showId})}
          icon={StoreMallDirectoryRoundedIcon}
          name={`${localMap.exhibitor} Shop`}
          endIcon={
            isShopDisabled && (
              <DisabledShopIcon tooltipTitle="Disabled by Organiser" />
            )
          }
        />
      </NavList>
      <Divider />
      <NavList>
        <NavItem
          to={generatePath(SHOW_SETTINGS_PATH, {showId})}
          icon={SettingsIcon}
          name="Show Settings"
        />
      </NavList>
    </Box>
  );
};

const SupplierNavigation: FC = () => {
  const params = useParams();
  const {showId} = params;
  const [isSupplierAdmin] = useIsSupplierCompanyAdmin();

  if (showId) {
    return <ShowNavigation showId={showId} />;
  }
  return (
    <Box>
      <NavList>
        <NavItem to={APP_PATH} icon={ListOutlinedIcon} name="Shows" />
        <NavItem to={PRODUCTS_LIST} icon={PackageIcon} name="Products" />
        <NavItem
          to={CUSTOM_OPTIONS_PATH}
          icon={CustomProductOptionIcon}
          name="Custom Options"
        />
        {isSupplierAdmin && (
          <NavItem
            to={OUTSTANDING_PAYMENTS_PATH}
            icon={AccountBalanceOutlinedIcon}
            name="Outstanding Payments"
          />
        )}
      </NavList>
      <Divider />
      <NavList>
        <NavItem to={SETTINGS_PATH} icon={SettingsIcon} name="Settings" />
      </NavList>
    </Box>
  );
};

export default SupplierNavigation;
